module.exports = __webpack_public_path__ + "static/customer_photo_3-2d75afa1b2decaee8c26e34f0e5a28dc.jpg";